// extracted by mini-css-extract-plugin
export default {"dates":"linkedPerson__dates___[chunkhash-base64-5]"};